const { useSelector } = require("react-redux");

const useProductParser = () => {
	const { allProducts } = useSelector((state) => state.products);

	const parseProductName = (_id) => {
		const productData = allProducts.find(
			(item) => item._id.toString() === _id
		);
		return productData?.name ?? "********";
	};

	return { parseProductName };
};

export default useProductParser;
